import { useNavigate, useParams } from "react-router-dom";
import Layout from "../components/Layout";
import CustomerSetup from "../components/_CustomerSetup";
import { CustomerContext } from "../contexts/CustomerContext";
import React from 'react'
import { PATHS } from "../utils/constant";

const CustomerSetUpPage = (props: any) => {

    const { customerConfig } = React.useContext(CustomerContext)
    const navigate = useNavigate()
  const { id } = useParams()

    React.useEffect(() => {
        if (!customerConfig.mobileNumber && !id) {
            navigate(PATHS.CUSTOMERS)
        }
    }, [])

    return (
        <Layout>
            <CustomerSetup />
        </Layout>
    )
}

export default CustomerSetUpPage